angular.module('app').controller('ExpensesCtrl', function($controller, $scope, appUtils, $http) {
    "ngInject";

    var main = this;
    main.name = 'expense';
    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));

    main.editExpense = function(item) {
        appUtils.quickDialog('ExpenseCtrl', 'expense.html', {'id': item.id}).then(
            function(data) {
                var idx = appUtils.indexOf(item, 'id', main.items);
                main.items[idx] = data;
            },
            console.log
        );
    };

    main.addExpense = function() {
        appUtils.embedNew('ExpenseCtrl', 'expense.html', []).then(function(data) {
            var url = '/api/v1/admin/' + main.name;
            main.loading = $http({'method': 'POST', url: url, 'data': data}).then(
                function(response) {
                    main.items.unshift(response.data);
                }
            );
        });
    };
});
